import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
/* ---------------- GET VALUATOR BOOKLET RECORD ---------------- */
export const fetchValuatorBookletRecord = createAsyncThunk(
	"valuator/fetchBookletRecord",
	async (valuatorCode, { rejectWithValue }) => {
		try {
			const response = await api.get(
				`/v1/Valuator/${valuatorCode}/valuationsetting`,
			);

			return response.data.data;
		} catch (err) {
			if (err.response?.status === 404) {
    return rejectWithValue("Data not found");
  }
  return rejectWithValue("Something went wrong");
		}
	},
);
const initialState = {
	data: [],
	loading: false,
	error: null,
	fetched: false,
};
const valuatorBookletRecordSlice = createSlice({
	name: "valuatorBookletRecord",
	initialState,
	reducers: {
		clearValuator: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchValuatorBookletRecord.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchValuatorBookletRecord.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
				state.fetched = true;
			})
			.addCase(fetchValuatorBookletRecord.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
				state.fetched = false;
			});
	},
});

export const { clearValuator } = valuatorBookletRecordSlice.actions;
export default valuatorBookletRecordSlice.reducer;
